import { UntitledIcon, type UntitledIconData } from '@faceup/icons'
import { Typography, Upload, type UploadProps } from '@faceup/ui-base'
import type { ReactNode } from 'react'
import { ucImagePlus } from '../customIcons'

export type UploadDragAndDropProps = {
  content?: {
    icon?: UntitledIconData
    text?: ReactNode
    hint?: ReactNode
    isPreview?: boolean
  }
} & UploadProps

export const UploadDragAndDrop = ({ content, ...props }: UploadDragAndDropProps) => {
  return (
    <Upload.Dragger {...props}>
      <div className='flex flex-col gap-4'>
        <UntitledIcon
          icon={content?.icon ?? ucImagePlus}
          className={
            props.disabled && !content?.isPreview ? 'text-colorTextDisabled' : 'text-colorPrimary'
          }
          size={32}
        />
        <div className='flex flex-col'>
          <Typography.Text type={props.disabled ? 'secondary' : undefined}>
            {content?.text}
          </Typography.Text>
          <Typography.Text size='sm' type='secondary'>
            {content?.hint}
          </Typography.Text>
        </div>
      </div>
    </Upload.Dragger>
  )
}
